module.exports = __webpack_public_path__ + "media/svg/pf-825474cb.svg";